"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UserRightsAndContact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return;
}
function ContactFormFields() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-[hsl(215,65%,95%)] border-2 border-[hsl(215,65%,45%)] rounded-lg text-center">
        <p className="text-[hsl(215,65%,33%)] font-semibold text-lg mb-4">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="bg-white hover:bg-[hsl(212,15%,95%)] border-[hsl(215,65%,45%)] text-[hsl(215,65%,45%)]">
          Submit Another Request
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-5">
        <FormField control={control} name="fullName" rules={{
        required: "Full name is required",
        minLength: {
          value: 2,
          message: "Name must be at least 2 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[hsl(210,10%,15%)] font-semibold">Full Name</FormLabel>
              <FormControl>
                <Input placeholder="Enter your full name" className="bg-white border-[hsl(212,15%,55%)] focus:border-[hsl(215,65%,45%)] focus:ring-[hsl(215,65%,45%)] transition-all duration-300 focus:translate-y-[-2px]" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[hsl(210,10%,15%)] font-semibold">Email Address</FormLabel>
              <FormControl>
                <Input type="email" placeholder="you@example.com" className="bg-white border-[hsl(212,15%,55%)] focus:border-[hsl(215,65%,45%)] focus:ring-[hsl(215,65%,45%)] transition-all duration-300 focus:translate-y-[-2px]" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        minLength: {
          value: 10,
          message: "Phone number must be at least 10 digits"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[hsl(210,10%,15%)] font-semibold">Phone Number (Optional)</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+1 (555) 123-4567" className="bg-white border-[hsl(212,15%,55%)] focus:border-[hsl(215,65%,45%)] focus:ring-[hsl(215,65%,45%)] transition-all duration-300 focus:translate-y-[-2px]" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="message" rules={{
        required: "Message is required",
        minLength: {
          value: 10,
          message: "Message must be at least 10 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[hsl(210,10%,15%)] font-semibold">Your Request</FormLabel>
              <FormControl>
                <textarea placeholder="Describe your data rights request or privacy concern..." rows={4} className="flex w-full rounded-md border border-[hsl(212,15%,55%)] bg-white px-3 py-2 text-base shadow-xs transition-all outline-none placeholder:text-[hsl(210,10%,60%)] focus:border-[hsl(215,65%,45%)] focus:ring-[3px] focus:ring-[hsl(215,65%,45%)]/50 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus:translate-y-[-2px]" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-4 bg-red-50 border-2 border-red-300 rounded-lg">
            <p className="text-red-800 text-sm font-medium">{submitError}</p>
          </div>}

        <Button type="submit" disabled={isSubmitting} className="w-full bg-[hsl(15,90%,55%)] hover:bg-[hsl(15,90%,48%)] text-white font-semibold py-3 rounded-md shadow-medium transition-all duration-300 hover:translate-y-[-2px] hover:shadow-strong active:translate-y-0 active:bg-[hsl(15,90%,43%)] disabled:opacity-60">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Submitting Request...
            </> : "Submit Request"}
        </Button>
      </div>
    </Form>;
}